import { Link } from "react-router-dom";
import { serviceCategories } from "@/mocks/home";

const categoryImages: Record<string, string> = {
  family: "https://readdy.ai/api/search-image?query=A%20warm%20modern%20living%20room%20with%20smart%20home%20security%20devices%2C%20subtle%20camera%20and%20sensor%20details%2C%20cozy%20natural%20lighting%2C%20family%20safe%20environment%2C%20clean%20minimalist%20interior%20design%2C%20professional%20product%20photography%2C%20soft%20warm%20ambient%20tones&width=800&height=500&seq=service-family&orientation=landscape",
  business: "https://readdy.ai/api/search-image?query=A%20modern%20corporate%20office%20building%20entrance%20with%20professional%20security%20access%20control%20system%2C%20glass%20facade%2C%20clean%20architectural%20design%2C%20bright%20daylight%2C%20corporate%20security%20concept%2C%20high%20quality%20architectural%20photography%2C%20professional%20atmosphere&width=800&height=500&seq=service-business&orientation=landscape",
  personal: "https://readdy.ai/api/search-image?query=A%20minimalist%20personal%20safety%20equipment%20display%20on%20a%20clean%20desk%2C%20modern%20alarm%20device%20and%20compact%20safety%20tools%2C%20soft%20natural%20lighting%20from%20window%2C%20clean%20product%20photography%20style%2C%20professional%20aesthetic%2C%20warm%20neutral%20background&width=800&height=500&seq=service-personal&orientation=landscape",
};

export default function ServiceCategories() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-4">
            全面的安全防护方案
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            无论您需要保护家庭、企业还是个人，安大师都有专业方案满足您的需求
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {serviceCategories.map((category, index) => (
            <Link
              key={category.id}
              to={category.link}
              className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden transition-all duration-300 hover:border-primary-300/50"
              style={{ animationDelay: `${index * 0.15}s` }}
            >
              <div className="relative h-52 overflow-hidden">
                <img
                  src={categoryImages[category.id]}
                  alt={category.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                <div className="absolute bottom-4 left-4 right-4">
                  <div className="flex items-center gap-2 mb-2">
                    <div className="w-8 h-8 bg-primary-500/90 rounded-md flex items-center justify-center">
                      <i className={`${category.icon} text-sm text-background-50`}></i>
                    </div>
                    <h3 className="text-lg font-bold text-background-50 font-heading">
                      {category.name}
                    </h3>
                  </div>
                </div>
              </div>
              <div className="p-5">
                <p className="text-sm text-foreground-600 mb-4 leading-relaxed">
                  {category.description}
                </p>
                <div className="flex flex-wrap gap-2">
                  {category.features.map((feat) => (
                    <span
                      key={feat}
                      className="text-xs px-2.5 py-1 bg-secondary-100 text-secondary-700 rounded-md whitespace-nowrap"
                    >
                      {feat}
                    </span>
                  ))}
                </div>
                <div className="mt-4 pt-4 border-t border-background-200/50 flex items-center justify-between">
                  <span className="text-sm font-medium text-primary-600 whitespace-nowrap">
                    了解详情
                  </span>
                  <i className="ri-arrow-right-line text-primary-500 group-hover:translate-x-1 transition-transform duration-200"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}